// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import Header from "../components/Header";
// import axios from "axios";

// function DailyTasks() {
//   const navigate = useNavigate();
//   const [tasks, setTasks] = useState([]);
//   const [taskNames, setTaskNames] = useState([]);
//   const [imageUrls, setImageUrls] = useState([]);
//   const [taskPage, setTaskPage] = useState(1);
//   const [imagePage, setImagePage] = useState(1);

//   const tasksPerPage = 2;
//   const imagesPerPage = 4;

//   useEffect(() => {
//     const fetchTasks = async () => {
//       try {
//         const token = localStorage.getItem("accessToken");
//         if (!token) {
//           console.error("No access token found.");
//           return;
//         }
    
//         const response = await axios.get("/user/dailyCompletedTasks", {
//           headers: { Authorization: `Bearer ${token}` },
//         });
    
//         if (!response.data.tasks || response.data.tasks.length === 0) {
//           setTasks([]);
//           return;
//         }
    
//         // Group tasks by date (excluding "N/A")
//         const groupedTasks = response.data.tasks.reduce((acc, task) => {
//           if (!task.completedDate) return acc; // Ignore tasks with no completedDate
    
//           const formattedDate = new Date(task.completedDate).toLocaleDateString("en-GB");
    
//           if (!acc[formattedDate]) {
//             acc[formattedDate] = {};
//           }
    
//           acc[formattedDate][task.name] = !!task.completedDate;
//           return acc;
//         }, {});
    
//         // Sort tasks by date (newest first)
//         const sortedTasks = Object.fromEntries(
//           Object.entries(groupedTasks).sort(
//             ([dateA], [dateB]) =>
//               new Date(dateB.split('/').reverse().join('-')) - new Date(dateA.split('/').reverse().join('-'))
//           )
//         );
    
//         // Extract unique task names
//         const uniqueTaskNames = [...new Set(response.data.tasks.map((task) => task.name))];
    
//         setTasks(sortedTasks);
//         setTaskNames(uniqueTaskNames);
//         setTaskPage(1); // Reset pagination to first page
//       } catch (error) {
//         console.error("Error fetching tasks:", error);
//       }
//     };
    
    
//     const fetchImages = async () => {
//       try {
//         const token = localStorage.getItem("accessToken");
//         const response = await axios.get("/user/getDisplayImages", {
//           headers: { Authorization: `Bearer ${token}` },
//         });
    
//         if (response.data.images) {
//           // Assuming images have a timestamp field like `createdAt`
//           const sortedImages = response.data.images
//             .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)) // Sort newest first
//             .map(img => `/uploads/${img.url}`);
    
//           setImageUrls(sortedImages);
//           setImagePage(1); // Always reset to first page when new images are fetched
//         }
//       } catch (error) {
//         console.error("Error fetching images:", error);
//       }
//     };

//     fetchTasks();
//     fetchImages();
//   }, []);

//   const taskEntries = Object.entries(tasks);
//   const totalTaskPages = Math.ceil(taskEntries.length / tasksPerPage);
//   const taskStartIndex = (taskPage - 1) * tasksPerPage;
//   const displayedTasks = taskEntries.slice(taskStartIndex, taskStartIndex + tasksPerPage);

//   const totalImagePages = Math.ceil(imageUrls.length / imagesPerPage);
//   const imageStartIndex = (imagePage - 1) * imagesPerPage;
//   const displayedImages = imageUrls.slice(imageStartIndex, imageStartIndex + imagesPerPage);

//   return (
//     <div>
//       <Header />
//       <div className="container mt-5">
//         <h1 className="text-center mb-4 fw-bold">📋 Daily Tasks</h1>
//         <div className="d-flex justify-content-end mb-4">
//           <button className="btn btn-primary shadow" onClick={() => navigate("/addDailytasks")}>
//             ➕ Add Daily Task
//           </button>
//         </div>

//         {/* Tasks List with Pagination */}
//         <div className="row">
//           {displayedTasks.map(([date, taskStatuses], index) => (
//             <div key={index} className="col-md-6">
//               <div className="card shadow-lg p-3 mb-4 rounded">
//                 <div className="card-header bg-dark text-white fw-bold">{date}</div>
//                 <div className="card-body">
//                   <ul className="list-group">
//                     {taskNames.map((task, idx) => (
//                       <li key={idx} className="list-group-item d-flex justify-content-between align-items-center">
//                         {task}
//                         {taskStatuses[task] ? (
//                           <span className="badge bg-success px-3 py-2">✔ Completed</span>
//                         ) : (
//                           <span className="badge bg-danger px-3 py-2">❌ Not Completed</span>
//                         )}
//                       </li>
//                     ))}
//                   </ul>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>

//         {/* Pagination for Tasks */}
//         {totalTaskPages > 1 && (
//           <div className="d-flex justify-content-center mt-3">
//             <button
//               className="btn btn-secondary me-2"
//               onClick={() => setTaskPage((prev) => Math.max(prev - 1, 1))}
//               disabled={taskPage === 1}
//             >
//               ⬅ Previous
//             </button>
//             <span className="fw-bold align-self-center">Page {taskPage} of {totalTaskPages}</span>
//             <button
//               className="btn btn-secondary ms-2"
//               onClick={() => setTaskPage((prev) => Math.min(prev + 1, totalTaskPages))}
//               disabled={taskPage === totalTaskPages}
//             >
//               Next ➡
//             </button>
//           </div>
//         )}

//         {/* Display Images Section */}
//         <h2 className="text-center mt-5">📷 Display Images</h2>
//         <div className="row justify-content-center">
//           {displayedImages.length > 0 ? (
//             displayedImages.map((url, index) => (
//               <div key={index} className="col-md-3 col-sm-6 mb-3">
//                 <img src={url} alt={`Display ${index + 1}`} className="img-fluid rounded shadow-lg" />
//               </div>
//             ))
//           ) : (
//             <p className="text-center text-muted">No images available</p>
//           )}
//         </div>

//         {/* Pagination for Images */}
//         {totalImagePages > 1 && (
//           <div className="d-flex justify-content-center mt-3">
//             <button
//               className="btn btn-secondary me-2"
//               onClick={() => setImagePage((prev) => Math.max(prev - 1, 1))}
//               disabled={imagePage === 1}
//             >
//               ⬅ Previous
//             </button>
//             <span className="fw-bold align-self-center">Page {imagePage} of {totalImagePages}</span>
//             <button
//               className="btn btn-secondary ms-2"
//               onClick={() => setImagePage((prev) => Math.min(prev + 1, totalImagePages))}
//               disabled={imagePage === totalImagePages}
//             >
//               Next ➡
//             </button>
//           </div>
//         )}
//       </div>

//       {/* Custom Styles */}
//       <style>{`
//         .card {
//           border-radius: 12px;
//         }
//         .card-header {
//           font-size: 1.2rem;
//           text-align: center;
//         }
//         .list-group-item {
//           font-size: 1rem;
//           font-weight: 500;
//           border: none;
//         }
//         .badge {
//           font-size: 0.9rem;
//         }
//         button:disabled {
//           opacity: 0.5;
//           cursor: not-allowed;
//         }
//         img {
//           width: 100%;
//           height: auto;
//           object-fit: cover;
//         }
//       `}</style>
//     </div>
//   );
// }

// export default DailyTasks;

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header";
import axios from "axios";
import { motion } from "framer-motion"; // ✅ Import motion

function DailyTasks() {
  const navigate = useNavigate();
  const [tasks, setTasks] = useState([]);
  const [taskNames, setTaskNames] = useState([]);
  const [imageUrls, setImageUrls] = useState([]);
  const [taskPage, setTaskPage] = useState(1);
  const [imagePage, setImagePage] = useState(1);

  const tasksPerPage = 2;
  const imagesPerPage = 4;

  useEffect(() => {
    const fetchTasks = async () => {
      try {
        const token = localStorage.getItem("accessToken");
        if (!token) return;

        const response = await axios.get("/user/dailyCompletedTasks", {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (!response.data.tasks || response.data.tasks.length === 0) {
          setTasks([]);
          return;
        }

        const groupedTasks = response.data.tasks.reduce((acc, task) => {
          if (!task.completedDate) return acc;
          const formattedDate = new Date(task.completedDate).toLocaleDateString("en-GB");
          if (!acc[formattedDate]) acc[formattedDate] = {};
          acc[formattedDate][task.name] = !!task.completedDate;
          return acc;
        }, {});

        const sortedTasks = Object.fromEntries(
          Object.entries(groupedTasks).sort(
            ([dateA], [dateB]) =>
              new Date(dateB.split("/").reverse().join("-")) -
              new Date(dateA.split("/").reverse().join("-"))
          )
        );

        const uniqueTaskNames = [...new Set(response.data.tasks.map((task) => task.name))];

        setTasks(sortedTasks);
        setTaskNames(uniqueTaskNames);
        setTaskPage(1);
      } catch (error) {
        console.error("Error fetching tasks:", error);
      }
    };

    const fetchImages = async () => {
      try {
        const token = localStorage.getItem("accessToken");
        const response = await axios.get("/user/getDisplayImages", {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (response.data.images) {
          const sortedImages = response.data.images
            .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
            .map((img) => `/uploads/${img.url}`);

          setImageUrls(sortedImages);
          setImagePage(1);
        }
      } catch (error) {
        console.error("Error fetching images:", error);
      }
    };

    fetchTasks();
    fetchImages();
  }, []);

  const taskEntries = Object.entries(tasks);
  const totalTaskPages = Math.ceil(taskEntries.length / tasksPerPage);
  const taskStartIndex = (taskPage - 1) * tasksPerPage;
  const displayedTasks = taskEntries.slice(taskStartIndex, taskStartIndex + tasksPerPage);

  const totalImagePages = Math.ceil(imageUrls.length / imagesPerPage);
  const imageStartIndex = (imagePage - 1) * imagesPerPage;
  const displayedImages = imageUrls.slice(imageStartIndex, imageStartIndex + imagesPerPage);

  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <Header />
      <div className="container mt-5">
        <motion.h1
          className="text-center mb-4 fw-bold"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2 }}
        >
          📋 Daily Tasks
        </motion.h1>
        <div className="d-flex justify-content-end mb-4">
          <motion.button
            className="btn btn-primary shadow"
            onClick={() => navigate("/addDailytasks")}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            ➕ Add Daily Task
          </motion.button>
        </div>

        {/* Tasks */}
        <div className="row">
          {displayedTasks.map(([date, taskStatuses], index) => (
            <motion.div
              key={index}
              className="col-md-6"
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
            >
              <div className="card shadow-lg p-3 mb-4 rounded">
                <div className="card-header bg-dark text-white fw-bold">{date}</div>
                <div className="card-body">
                  <ul className="list-group">
                    {taskNames.map((task, idx) => (
                      <li key={idx} className="list-group-item d-flex justify-content-between align-items-center">
                        {task}
                        {taskStatuses[task] ? (
                          <span className="badge bg-success px-3 py-2">✔ Completed</span>
                        ) : (
                          <span className="badge bg-danger px-3 py-2">❌ Not Completed</span>
                        )}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Pagination */}
        {totalTaskPages > 1 && (
          <div className="d-flex justify-content-center mt-3">
            <button
              className="btn btn-secondary me-2"
              onClick={() => setTaskPage((prev) => Math.max(prev - 1, 1))}
              disabled={taskPage === 1}
            >
              ⬅ Previous
            </button>
            <span className="fw-bold align-self-center">
              Page {taskPage} of {totalTaskPages}
            </span>
            <button
              className="btn btn-secondary ms-2"
              onClick={() => setTaskPage((prev) => Math.min(prev + 1, totalTaskPages))}
              disabled={taskPage === totalTaskPages}
            >
              Next ➡
            </button>
          </div>
        )}

        {/* Display Images */}
        <motion.h2
          className="text-center mt-5"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3 }}
        >
          📷 Display Images
        </motion.h2>
        <div className="row justify-content-center">
          {displayedImages.length > 0 ? (
            displayedImages.map((url, index) => (
              <motion.div
                key={index}
                className="col-md-3 col-sm-6 mb-3"
                initial={{ scale: 0.9, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                transition={{ delay: index * 0.1 }}
              >
                <img src={url} alt={`Display ${index + 1}`} className="img-fluid rounded shadow-lg" />
              </motion.div>
            ))
          ) : (
            <p className="text-center text-muted">No images available</p>
          )}
        </div>

        {/* Pagination for Images */}
        {totalImagePages > 1 && (
          <div className="d-flex justify-content-center mt-3">
            <button
              className="btn btn-secondary me-2"
              onClick={() => setImagePage((prev) => Math.max(prev - 1, 1))}
              disabled={imagePage === 1}
            >
              ⬅ Previous
            </button>
            <span className="fw-bold align-self-center">
              Page {imagePage} of {totalImagePages}
            </span>
            <button
              className="btn btn-secondary ms-2"
              onClick={() => setImagePage((prev) => Math.min(prev + 1, totalImagePages))}
              disabled={imagePage === totalImagePages}
            >
              Next ➡
            </button>
          </div>
        )}
      </div>
    </motion.div>
  );
}

export default DailyTasks;
